import axios from 'axios';
import { authService } from './authService';
import { ENDPOINTS } from '../config/endpoints';

const API_BASE = ENDPOINTS.summarize;

// Потолок ожидания ответа ассистента. Без него axios ждёт БЕСКОНЕЧНО: при
// зависшей модели «Печатает…» висело до перезагрузки страницы, и человек не
// знал, сорвалось или ещё идёт (замечание владельца 08.09.2026). Минута —
// его же граница: дольше ответ в диалоге не нужен, лучше сказать честно.
const CHAT_TIMEOUT_MS = 60000;

export const chatService = {
  async send(message, context, history, model) {
    const { data } = await axios.post(
      API_BASE + '/chat',
      {
        message,
        context_transcription: context.transcription || null,
        context_protocol: context.protocol || null,
        history,
        model,
        // Когда была встреча — для сроков «до пятницы» (bit-llm-summarize/meeting_date.py).
        meeting_at: context.meetingAt || null,
      },
      { headers: authService.getAuthHeaders(), timeout: CHAT_TIMEOUT_MS }
    );
    return data.response;
  },

  // Правка протокола: на вход текущий текст и просьба, на выход реплика и
  // новая полная версия (bit-llm-summarize, mode=edit). Пакет протоколов не
  // тратит. Историю чата не шлём: прошлые правки уже применены или отклонены.
  async edit(message, { transcription, protocol, meetingAt }, model) {
    const { data } = await axios.post(
      API_BASE + '/chat',
      {
        message,
        mode: 'edit',
        context_transcription: transcription || null,
        context_protocol: protocol,
        history: [],
        meeting_at: meetingAt || null,
        model,
      },
      { headers: authService.getAuthHeaders(), timeout: CHAT_TIMEOUT_MS }
    );
    // Старый bit-llm-summarize не знает mode и отдаёт только {response}:
    // тогда «новая версия» — это исходный текст, и правки просто не будет.
    // Без этой страховки «Применить» записало бы в протокол undefined.
    return { reply: data.response, protocol: typeof data.protocol === 'string' ? data.protocol : protocol };
  },
};
